import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'
import { currentLocale } from './services/translationService'

// Production loads every key (src/l10n/locale/*.json): shadow mode, until the tenant-profile labels are verified on
// stag and dev. Every other environment loads only the keys labeled tenant-profile (src/l10n/tenant-profile.json,
// { key: [en, nl_BE, fr] }). Both are written by yarn translations. REACT_APP_ENV is replaced by a constant at build
// time and webpack skips the require in the branch that cannot run, so a bundle holds exactly one of the two.
// The two branches must stay an if/else: webpack only skips a require that sits in the branch it can rule out.
const loadMessages = () => {
  if (process.env.REACT_APP_ENV === 'production') {
    return [require('./l10n/locale/en.json'), require('./l10n/locale/nl_BE.json'), require('./l10n/locale/fr.json')]
  } else {
    const translations = require('./l10n/tenant-profile.json')
    const perLocale = [{}, {}, {}]
    Object.keys(translations).forEach(key => {
      translations[key].forEach((text, index) => {
        if (text !== null) perLocale[index][key] = text
      })
    })
    return perLocale
  }
}

const [message_en, message_nl, message_fr] = loadMessages()

i18n.use(reactI18nextModule).init({
  fallbackLng: currentLocale(),
  debug: process.env.REACT_APP_I18N_DEBUG === 'true',
  resources: {
    nl_BE: {
      translation: message_nl,
    },
    en_US: {
      translation: message_en,
    },
    fr_FR: {
      translation: message_fr,
    },
  },
  keySeparator: false,
  nonExplicitWhitelist: true,
  whitelist: ['en_US', 'nl_BE', 'fr_FR'],
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js